import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { fetchProject } from "../redux/actions/projectAction";
import { useAppDispatch } from "../redux/hook";
import { FiHexagon } from "../assets/icons/vander";
import Pagination from "../utils/Pagination";

export default function Projects({ pagination = true }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Pagination start
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(3);
  // Pagination end

  const [projectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadProject = async () => {
    const data = {
      page: page,
      limit: limit,
    };

    const project = await dispatch(fetchProject(data));
    if (typeof project.payload === "string" || project.payload === undefined) {
      setLoading(false);
      // navigate(checkError(homeEdit.payload));
    } else {
      setLoading(false);
      setProjectData(project.payload.project);
      setTotalPages(project.payload.totalPages);
      setTotal(project.payload.total);
      setPage(project.payload.page);
      setLimit(project.payload.limit);
    }
  };
  loadProject();

  useEffect(() => {
    loadProject(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative md:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-6 md:text-2xl text-xl font-medium">
            {t("external.project.our_projects")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.project.here_there_are_some_of_our_projects")}
          </p>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
          {pagination
            ? projectData?.map((item, index) => {
                return (
                  <div
                    className="group relative lg:px-6 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center"
                    key={index}
                  >
                    <div className="relative overflow-hidden text-transparent -m-3">
                      <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                      <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className="h-8"
                          alt=""
                        />
                      </div>
                    </div>

                    <div className="mt-6">
                      <Link
                        to={`/project/${item.id}`}
                        className="text-lg font-medium duration-500 hover:text-orange-500"
                      >
                        {item.name}
                      </Link>
                      <p className="text-slate-400 dark:text-white/60 text-[15px] duration-500 mt-3">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })
            : projectData?.slice(0, 3).map((item, index) => {
                return (
                  <div
                    className="group relative lg:px-6 transition duration-500 ease-in-out rounded-xl overflow-hidden text-center"
                    key={index}
                  >
                    <div className="relative overflow-hidden text-transparent -m-3">
                      <FiHexagon className="h-28 w-28 fill-orange-500/5 mx-auto rotate-[30deg]" />
                      <div className="absolute top-2/4 -translate-y-2/4 start-0 end-0 mx-auto text-orange-500 rounded-xl transition duration-500 ease-in-out text-3xl flex align-middle justify-center items-center">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className="h-8"
                          alt=""
                        />
                      </div>
                    </div>

                    <div className="mt-6">
                      <Link
                        to={`/project/${item.id}`}
                        className="text-lg font-medium duration-500 hover:text-orange-500"
                      >
                        {item.name}
                      </Link>
                      <p className="text-slate-400 dark:text-white/60 text-[15px] duration-500 mt-3">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
        </div>

        {pagination && (
          <Pagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
            total={total}
          />
        )}
      </div>
    </>
  );
}
